export default {
  name: 'lx-validation-error',
  props: {
    error: String,
    static: Boolean,
  },
}
